const NewsList = {
    articles: null,
    categories: [],
    topics: [],
    q: null,
    newsListEl: null,
    selectedCat: null,
    noneEl: null,
    newsRootId: null,
    articleType: "News",

    populate: (articles) => {
        const template = NewsList.newsListEl.querySelector(".template > div")
        const container = template.closest(".area-container")
        NewsList.articles = articles
        container.querySelectorAll(".article").forEach(articleEl => {
            articleEl.remove()
        })
        NewsList.articles.forEach(article => {
            const articleEl = template.cloneNode(true)
            articleEl.classList.add("article")
            let imgUrl = article.imgUrl
            if (!imgUrl) {
                imgUrl = "/img/tourism/placeholder.svg"
            }
            articleEl.querySelector("a").setAttribute("href", article.url);
            if (article.tag1) {
                articleEl.querySelector(".tag1").innerText = article.tag1
            } else {
                articleEl.querySelector(".tag1").remove()
            }
            if (article.tag2) {
                articleEl.querySelector(".tag2").innerText = article.tag2
            } else {
                articleEl.querySelector(".tag2").remove()
            }
            if (article.tag3) {
                articleEl.querySelector(".tag3").innerText = article.tag3
            } else {
                articleEl.querySelector(".tag3").remove()
            }
            articleEl.querySelector(".day").innerText = article.day
            articleEl.querySelector(".dt").innerText = article.date
            articleEl.querySelector(".title").innerText = article.name
            //articleEl.querySelector(".summary").innerText = article.description
            //if (!article.description) {
            //    articleEl.querySelector(".summary").remove()
            //}
            articleEl.querySelector("img").setAttribute("src", imgUrl)

            const timeEl = articleEl.querySelector(".time")
            if (article.time) {
                timeEl.innerText = article.time
            } else {
                timeEl.remove()
            }
            const locationEl = articleEl.querySelector(".location")
            if (article.location) {
                locationEl.innerText = article.location
            } else {
                locationEl.remove()
            }
            const iconsEl = articleEl.querySelector(".icons")

            NewsList.addIcon(iconsEl, article.icon1)
            NewsList.addIcon(iconsEl, article.icon2)
            NewsList.addIcon(iconsEl, article.icon3)

            const favEl = articleEl.querySelector(".fav-item")

            NewsList.addFavourite(favEl, article.id)

            container.appendChild(articleEl)
            //console.log(articleEl.innerHTML)
            //console.log(articles)
        })
        NewsList.newsListEl.querySelector(".numitems").innerHTML = articles.length
        //NewsList.noneEl.classList.remove("active")
        //if (articles.length == 0) {
        //    NewsList.noneEl.classList.add("active")
        //}

    },

    addFavourite: (favEl, id) => {
        if (window.memberFavourites) {
            favEl.dataset.id = id
            const imgEl = document.createElement("img")
            imgEl.title = "favourite"
            imgEl.alt = ""
            imgEl.src = "/img/tourism/heart-16";
            if (!window.memberFavourites.includes(id)) {
                imgEl.src += "-outline" 
            }
            imgEl.src += ".svg"
            favEl.appendChild(imgEl)
        }

    },

    addIcon: (iconsEl, icon) => {
        if (icon) {
            const iconEl = document.createElement("div")
            iconEl.classList.add("icon")
            const inner = document.createElement("div")
            iconEl.appendChild(inner)
            const imgEl = document.createElement("img")
            let iconName = icon.replace(".svg", "").replace("icon-", "").replace("-", " ")
            iconName = String(iconName).charAt(0).toUpperCase() + String(iconName).slice(1);
            imgEl.src = "/img/tourism/tagicons/" + icon;
            imgEl.title = iconName
            imgEl.alt = iconName
            inner.appendChild(imgEl)
            iconsEl.appendChild(iconEl)
        }
    },

    setupCategoryFilter: (cats) => {
        const filterEl = NewsList.newsListEl.querySelector(".cat-filter")
        filterEl.innerHTML = ""
        const categories = NewsList.getCategories(NewsList.articles)
        if (categories.length == 0) {
            filterEl.parentNode.style.display = "none"
        } else {
            filterEl.parentNode.style.display = "block"
        }

        categories.forEach(cat => {
            const catEl = document.createElement("div")
            catEl.innerText = cat
            if (NewsList.categories.includes(cat)) {
                catEl.classList.add("active")
            }
            catEl.addEventListener("click", () => {
                const removed = NewsList.categories.includes(cat);
                if (NewsList.categories.includes(cat)) {
                    NewsList.categories.splice(NewsList.categories.indexOf(cat), 1);
                    catEl.classList.remove("active")
                } else {
                    NewsList.categories.push(cat)
                    catEl.classList.add("active")
                }
                NewsList.getArticles((articles) => {
                    NewsList.populate(articles)
                    NewsList.setupTopicFilter()
                    if (removed) {
                        NewsList.setupCategoryFilter()
                    }
                })
            })
            filterEl.appendChild(catEl)
        })
    },

    setupTopicFilter: () => {
        const filterEl = NewsList.newsListEl.querySelector(".tag-filter")
        if (filterEl) {
            filterEl.innerHTML = ""
            const topics = NewsList.getTopics(NewsList.articles)
            if (topics.length == 0) {
                filterEl.parentNode.style.display = "none"
            } else {
                filterEl.parentNode.style.display = "block"
            }
            topics.forEach(topic => {
                const topicEl = document.createElement("div")
                topicEl.innerHTML = topic
                if (NewsList.topics.includes(topic)) {
                    topicEl.classList.add("active")
                }
                topicEl.addEventListener("click", () => {
                    const removed = NewsList.topics.includes(topic)
                    if (NewsList.topics.includes(topic)) {
                        NewsList.topics.splice(NewsList.topics.indexOf(topic), 1);
                        topicEl.classList.remove("active")
                    } else {
                        NewsList.topics.push(topic)
                        topicEl.classList.add("active")
                    }

                    NewsList.getArticles((articles) => {
                        NewsList.populate(articles)
                        NewsList.setupCategoryFilter()
                        if (removed) {
                            NewsList.setupTopicFilter()
                        }
                    })
                })
                filterEl.appendChild(topicEl)
            })
        }
    },


    getCategories: (articles) => {
        let result = [];
        articles.forEach(article => {
            if (!result.includes(article.cat) && article.cat != '') {
                result.push(article.cat)
            }
        })
        result.sort()
        return result;
    },

    getTopics: (articles) => {
        let result = [];
        articles.forEach(article => {
            if (!result.includes(article.topic) && article.topic != '') {
                result.push(article.topic)
            }
        })
        result.sort()
        return result;
    },

    setUpClear: () => {
        const clearEl = NewsList.newsListEl.querySelector(".clear")
        clearEl.addEventListener("click", () => {
            NewsList.clearFilters()
        })
    },

    clearFilters: () => {
        NewsList.categories = []
        NewsList.topics = []
        NewsList.q = ""
        const searchEl = NewsList.newsListEl.querySelector(".search")
        if (searchEl) {
            const searchInput = searchEl.querySelector("input")
            searchInput.val = ""
        }
        NewsList.getArticles((articles) => {
            NewsList.populate(articles)
            NewsList.setupCategoryFilter()
            NewsList.setupTopicFilter()
        })

    },



    getArticles: (callback) => {
        const requestVerificationToken = NewsList.newsListEl
            .querySelector("input[name='__RequestVerificationToken']").value
        const key = document.querySelector(".latestnews[data-key]").dataset.key
        //console.log(key)
        fetch("/umbraco/surface/NewsList", {
            cache: 'no-store',
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "RequestVerificationToken": requestVerificationToken,
            },
            body: JSON.stringify({
                topics: NewsList.topics,
                cats: NewsList.categories,
                q: NewsList.q,
                newsRootId: NewsList.newsRootId,
                articleType: NewsList.articleType,
                key: key
            })
        }).then(resp => {
            resp.json().then(data => {
                //console.log(data)
                if (data && data.articles) {

                    if (callback) {
                        callback(data.articles)
                    }
                }
            })
        })
    },

    setUpFunnel: () => {
        const filterEl = NewsList.newsListEl.querySelector(".filter")
        const funnelEl = filterEl.querySelector(".funnel")
        const selectionsEl = filterEl.querySelector(".filter-selections")
        funnelEl.addEventListener("click", () => {
            if (selectionsEl.classList.contains("hide")) {
                selectionsEl.classList.remove("hide")
            } else {
                selectionsEl.classList.add("hide")
            }
        })
    },

    setupMobileFilter: () => {
        const filterEl = NewsList.newsListEl.querySelector(".filter")
        const catLabelEl = filterEl.querySelector(".catlabel")
        const tagLabelEl = filterEl.querySelector(".taglabel")

        const catFilterEl = filterEl.querySelector(".cat-filter")
        const tagFilterEl = filterEl.querySelector(".tag-filter")

        catLabelEl.addEventListener("click", () => {
            catFilterEl.classList.remove("active")
            tagFilterEl.classList.remove("active")
            catFilterEl.classList.add("active")

            catLabelEl.classList.remove("active")
            tagLabelEl.classList.remove("active")
            catLabelEl.classList.add("active")
        })
        if (tagLabelEl) {
            tagLabelEl.addEventListener("click", () => {
                catFilterEl.classList.remove("active")
                tagFilterEl.classList.remove("active")
                tagFilterEl.classList.add("active")

                catLabelEl.classList.remove("active")
                tagLabelEl.classList.remove("active")
                tagLabelEl.classList.add("active")
            })
        }
    },

    init: () => {
        NewsList.newsListEl = document.querySelector(".latestnews")
        if (NewsList.newsListEl) {
            if (NewsList.newsListEl.dataset.saved) {
                var saved = JSON.parse(NewsList.newsListEl.dataset.saved);
                NewsList.categories = saved && saved.Categories ? saved.Categories : []
                NewsList.topics = saved && saved.Topics ? saved.Topics :  []
            }
            NewsList.newsRootId = NewsList.newsListEl.dataset.newsrootid;
            NewsList.articleType = NewsList.newsListEl.dataset.articletype;
            NewsList.setupMobileFilter()
            NewsList.setUpFunnel()
            const formEl = NewsList.newsListEl.querySelector("form")
            formEl.addEventListener("submit", (e) => {
                e.preventDefault()
            })
            NewsList.getArticles((articles) => {
                NewsList.populate(articles)

                const categories = NewsList.getCategories(articles)
                const topics = NewsList.getTopics(articles)
                if (topics.length == 0 && categories.length == 0) {
                    const filterEl = NewsList.newsListEl.querySelector(".filter")
                    filterEl.style.display = "none"
                } else {
                    NewsList.setupCategoryFilter()
                    NewsList.setupTopicFilter()
                    NewsList.setUpClear()
                    if ((NewsList.topics && NewsList.topics.length) || (NewsList.categories && NewsList.categories.length)) {
                        NewsList.newsListEl.querySelector(".filter-selections").classList.remove("hide")
                    }
                }
            })
        }
    }
};

NewsList.init();